module.exports = __webpack_public_path__ + "media/hemangioma.b2575169.wav";